
import styles from './ShopBody.module.css';
import ShopItem from './shop/ShopItem';
import AmazonShopItem from './shop/AmazonShopItem';
import Title from './Title';

export default function ShopBody() {
  return (
    <div className={styles.pageContainer}>
      <Title>Welcome to the Shop</Title>
      <div className={styles.introText}>
        <em>Coming soon...</em>
      </div>
      {/*<div className={styles.introText}>
        We're still hard at work on our own products to help you improve your game, but here are some items that we recommend:
      </div>
      <div className={styles.container}>
        <div className={styles.item}>
          <b>Pro Pull</b>
          <p>The Pro Pull is a disc attached to a resistance band that helps you strengthen your throwing muscles, practice your routine, and aids in stretching to prevent injury. We love the Pro Pull because it allows us to feel which muscles and movements are involved in the throw.</p>
          <AmazonShopItem 
              title="Pro Pull"
              code='<iframe sandbox="allow-popups allow-scripts allow-modals allow-forms allow-same-origin" style="width:120px;height:240px;" marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ss&ref=as_ss_li_til&ad_type=product_link&tracking_id=dgpl-20&language=en_US&marketplace=amazon&region=US&placement=B07Q32V45S&asins=B07Q32V45S&linkId=ec0520a45839580ec6e395d5bd291ca2&show_border=true&link_opens_in_new_window=true"></iframe>'
          />
        </div>
        <div className={styles.item}>
          <b>Practice Net</b>
          <p>A practice net is great for doing fieldwork without the need of a field. It can help you practice your throwing motion.</p>
          <AmazonShopItem 
              title="Practice Net"
              code='<iframe sandbox="allow-popups allow-scripts allow-modals allow-forms allow-same-origin" style="width:120px;height:240px;" marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ss&ref=as_ss_li_til&ad_type=product_link&tracking_id=dgpl-20&language=en_US&marketplace=amazon&region=US&placement=B079JDQKV4&asins=B079JDQKV4&linkId=2a8ee5c00601136bae03382a3233ee74&show_border=true&link_opens_in_new_window=true"></iframe>'
          />
        </div>
        <div className={styles.item}>
          <b>Portable Basket</b>
          <p>A portable basket is great for practicing putts or setting up a spontaneous course.</p>
          <AmazonShopItem 
              title="Practice Basket"
              code='<iframe sandbox="allow-popups allow-scripts allow-modals allow-forms allow-same-origin" style="width:120px;height:240px;" marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ss&ref=as_ss_li_til&ad_type=product_link&tracking_id=dgpl-20&language=en_US&marketplace=amazon&region=US&placement=B079MBNMM7&asins=B079MBNMM7&linkId=1b0e9354232ccb647bdf22b9f072441d&show_border=true&link_opens_in_new_window=true"></iframe>'
          />
        </div>
        <div className={styles.item}>
          <b>Grip Strength Trainer</b>
          <p>A stronger grip allows you to put greater spin on the disc and prevents early releases. A grip strength trainer can increase your grip strength.</p>
          <AmazonShopItem 
              title="Grip Strength Trainer"
              code='<iframe sandbox="allow-popups allow-scripts allow-modals allow-forms allow-same-origin" style="width:120px;height:240px;" marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ss&ref=as_ss_li_til&ad_type=product_link&tracking_id=dgpl-20&language=en_US&marketplace=amazon&region=US&placement=B0838G23M1&asins=B0838G23M1&linkId=b0d1b905cc5a63b66d9c31d40d623bda&show_border=true&link_opens_in_new_window=true"></iframe>'
          />
        </div>
        <div className={styles.item}>
          <b>Resin Bag</b>
          <p>Sweaty palms? A resin bag will help dry your hands to ensure you retain proper grip on the disc.</p>
          <AmazonShopItem 
              title="Resin Bag"
              code='<iframe sandbox="allow-popups allow-scripts allow-modals allow-forms allow-same-origin" style="width:120px;height:240px;" marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ss&ref=as_ss_li_til&ad_type=product_link&tracking_id=dgpl-20&language=en_US&marketplace=amazon&region=US&placement=B077TY6VTZ&asins=B077TY6VTZ&linkId=0f0ccc88c4dd88d7162faa13224d09f2&show_border=true&link_opens_in_new_window=true"></iframe>'
          />
        </div>
        <div className={styles.item}>
          <b>Disc Retriever</b>
          <p>Love your discs? We do. A disc retriever can help prevent you from losing them (or throwing rocks at trees, which we are all too familiar with).</p>
          <AmazonShopItem 
              title="Disc Retriever"
              code='<iframe sandbox="allow-popups allow-scripts allow-modals allow-forms allow-same-origin" style="width:120px;height:240px;" marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ss&ref=as_ss_li_til&ad_type=product_link&tracking_id=dgpl-20&language=en_US&marketplace=amazon&region=US&placement=B08YLYRKMV&asins=B08YLYRKMV&linkId=1cf4e61893a433214930b1845e9afa03&show_border=true&link_opens_in_new_window=true"></iframe>'
          />
    </div>*/}
        {/*<h5>Coming soon</h5>*/}
        {/*<ShopItem
          title="Logo T-Shirt"
          img="./shop/logo-tshirt.png"
          price={25.00}
          amazon=false
        />
        <ShopItem
          title="Sticker"
          img="./shop/logo_black_large_transparent.png"
          price={5.00}
          amazon=false
        />*/}
    </div>
  )
}

